module.exports = __webpack_public_path__ + "img/201710-2.752cc317.jpg";